import { ContentSidebarLayout, useLayout, useTranslation } from '@ukpostbox/frontend-framework';
import React, { useEffect, useRef } from 'react';
import SendsNavigation from '../../../SendMail/Components/Shared/Controls/SendsNavigation';
import SendsHistoryControl from '../Components/Controls/SendsHistoryControl';
import SendMailHistoryProvider from '../../Providers/SendMailHistoryProvider';
import SendsHistoryFilterControl, { SendHistoryFilterButton } from '../Components/Controls/SendsHistoryFilterControl';
import { useSite } from '../../../_Global/Providers/SiteInterfaceProvider';

function History() {
	const { t } = useTranslation();
	const { isTiny, isSmall, isMedium } = useLayout();
	const { currentLocale, updatePageMeta } = useSite();
	const sendsHistoryRef = useRef<any>(null);
	const sendMailNavigationRef = useRef<any>(null);

	useEffect(() => {
		updatePageMeta({
			title: t('sends.profilesHistory.title'),
		});
	}, [currentLocale]);

	return (
		<SendMailHistoryProvider>
			<ContentSidebarLayout
				ref={sendsHistoryRef}
				navigationComponent={
					<SendsNavigation
						ref={sendMailNavigationRef}
						title={t('sends.profilesHistory.title')}
						addonContent={
							(isTiny || isSmall || isMedium) && (
								<>
									<SendHistoryFilterButton />
									<SendsHistoryFilterControl />
								</>
							)
						}
					/>
				}
				extraContentClass={`flex-column `}
			>
				<SendsHistoryControl linkToSendsItem containerRef={sendsHistoryRef} />
			</ContentSidebarLayout>
		</SendMailHistoryProvider>
	);
}

export default History;
